var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useCallback } from 'react';
import { ModalCover } from './ModalCover';
import { useDocumentKeydown } from '../hooks/useDocumentKeydown';
import { Card } from './Card';
import { CustomScroll } from './CustomScroll';
export var Modal = function (_a) {
    var title = _a.title, onHide = _a.onHide, className = _a.className, children = _a.children;
    useDocumentKeydown(useCallback(function (e) {
        if (onHide && !e.defaultPrevented && e.key === 'Escape') {
            onHide();
        }
    }, [onHide]));
    return (jsx(ModalCover, { onMouseDown: onHide &&
            (function (e) {
                e.stopPropagation();
                onHide();
            }) },
        jsx(Card, { sx: {
                minWidth: [undefined, 400],
                width: ['100%', undefined],
                maxHeight: '100vh',
                maxWidth: ['100vw', 600],
                dropShadow: function (t) { return t.dropShadow; },
                display: 'flex',
                flexDirection: 'column',
            }, className: className, onClick: function (e) {
                e.stopPropagation();
            }, onMouseDown: function (e) {
                e.stopPropagation();
            } },
            title && (jsx("div", { sx: { p: 3, textAlign: 'center', fontSize: 3 } }, title)),
            children)));
};
export var ModalBody = function (props) {
    return jsx(CustomScroll, __assign({ sx: { p: 3 } }, props));
};
export var ModalFooter = function (props) {
    return (jsx("div", __assign({}, props, { sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            p: 3,
            '&>*:not(:first-of-type)': {
                ml: 2,
            },
        } })));
};
//# sourceMappingURL=Modal.js.map